// trial_meal.js (Fixed & Improved)
document.addEventListener("DOMContentLoaded", () => {

  const allSelects = document.querySelectorAll(".selinside");
  const allRadios = document.querySelectorAll(".radio_m");
  const allTextAreas = document.querySelectorAll(".note1skipnmix");
  const allInputs = document.querySelectorAll(".val-input");
  const overlayBtn = document.querySelector(".btn_overlays");
  const msg = document.querySelector(".fillMessage");

  // Show overlay if clicked
  overlayBtn.addEventListener("click", () => {
    msg.style.display = "block";
  });

  // Check if all inputs are filled
  function checkAllValues() {
    let allFilled = true;
    allInputs.forEach(input => {
      if (input.value === "") allFilled = false;
    });

    if (allFilled) {
      overlayBtn.style.display = "none";
      msg.style.display = "none";
    } else {
      overlayBtn.style.display = "block";
    }
  }

  checkAllValues();

  // Handle skip textarea input
  allTextAreas.forEach(textarea => {
    textarea.addEventListener("input", () => {
      const parent = textarea.closest(".mealweekm_main");
      const hiddenInput = parent.querySelector(".val-input");
      const radio = parent.querySelector(".radio_m");
      const mealName = parent.dataset.mealname || "Meal";
      
      // Only update if skip is checked
      if (radio && radio.checked) {
        hiddenInput.name = "properties[" + mealName + "]";
        hiddenInput.value = textarea.value ? "(skip) " + textarea.value : "Skipped";
      }
      
      checkAllValues();
    });
  });

  // Handle skip checkbox
  allRadios.forEach(radio => {
    radio.addEventListener("click", () => {
      const parent = radio.closest(".mealweekm_main");
      const hiddenInput = parent.querySelector(".val-input");
      const textarea = parent.querySelector(".note1skipnmix");
      const textDiv = parent.querySelector(".skip1mixm");
      const label = parent.querySelector("label");
      const select = parent.querySelector(".selinside");
      const mealName = parent.dataset.mealname || "Meal";
      hiddenInput.name = "properties[" + mealName + "]";

      if (radio.checked) {
        if (select) select.selectedIndex = 0;
        if (label) label.classList.add("check");
        if (textDiv) textDiv.style.display = "block";
        hiddenInput.value = textarea && textarea.value ? "(skip) " + textarea.value : "Skipped";
      } else {
        if (textDiv) textDiv.style.display = "none";
        hiddenInput.value = "";
        if (textarea) textarea.value = "";
        if (label) label.classList.remove("check");
      }

      checkAllValues();
    });
  });

  // Handle select dropdown change
  allSelects.forEach(select => {
    select.addEventListener("change", () => {
      const parent = select.closest(".mealweekm_main");
      const hiddenInput = parent.querySelector(".val-input");
      const textarea = parent.querySelector(".note1skipnmix");
      const textDiv = parent.querySelector(".skip1mixm");
      const radio = parent.querySelector(".radio_m");
      const label = parent.querySelector("label");
      const mealName = parent.dataset.mealname || "Meal";

      hiddenInput.name = "properties[" + mealName + "]";
      hiddenInput.value = select.value.trim();
      if (radio) radio.checked = false;
      if (label) label.classList.remove("check");
      if (radio) radio.classList.remove("checkrr");
      if (textarea) textarea.value = "";
      if (textDiv) textDiv.style.display = "none";

      checkAllValues();
    });
  });

  // ===== Ensure properties are set before form submission =====
  // Intercept both form submit and add-to-cart button click
  const productForm = document.querySelector('form.ProductForm');
  const addToCartButton = document.querySelector('[data-action="add-to-cart"]');
  
  function ensurePropertiesSet() {
    // Ensure all hidden inputs have proper names and values before submission
    allInputs.forEach(input => {
      if (input.value) {
        const parent = input.closest('.mealweekm_main');
        if (parent) {
          const mealName = parent.dataset.mealname || 'Meal';
          if (!input.name || !input.name.includes('properties[')) {
            input.name = 'properties[' + mealName + ']';
          }
        }
      }
    });
  }
  
  if (productForm) {
    productForm.addEventListener('submit', ensurePropertiesSet);
  }
  
  if (addToCartButton) {
    // Use capture phase to ensure this runs BEFORE the theme's AJAX handler
    // This ensures properties are set before form serialization happens
    addToCartButton.addEventListener('click', function(e) {
      ensurePropertiesSet();
    }, true); // true = capture phase (runs before bubble phase)
  }

});
